export function Spacer() {
	return <div class="flex-1 shrink"></div>;
}
